import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '../../http/base-http.service';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class SkillSetsDataService extends BaseHttpService {

    private urls: any = {
        allSkillSets: '/skillsets?all=true'
    };

    protected override initApiEndpoint() {
        this.apiEndpoint = environment.api.endpointV2;
    }

    fetchSkillSets(): Observable<any> {
        return this.get(this.urls.allSkillSets);
    }
}
